import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {navigator} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {property} from 'lit/decorators/property.js';

import store from '../../store';
import {setDownloadPanelSpecsheetActive} from '../../slices/statusSlice';
import {downloadPDF, downloadPNG} from '../../slices/downloadSlice';
import {storeConfiguration, updatePersonalisation} from '../../slices/configurationSlice';

import arrowAltLeft from '../../../icons/arrow-alt-left';
import reset from '../../../icons/reset';
import download from '../../../icons/download';
import checkmark from '../../../icons/checkmark';
import loading from '../../../icons/loading';
import personalisation from '../../../icons/personalisation';

import {
	selectSpcIsSatisfied,
	selectLdt1,
	selectLdt2,
	selectMountingInstruction,
	selectSpcSession,
	selectSpcConfiguration,
	selectBasicSpcAttributes,
	selectDetailSpcAttributes,
	selectBasicSpcAttributesSatisfied,
	selectRelux,
	selectProductImagesUrl, selectFamily, selectFamilyFile, selectHasPersonalisation, selectShowPersonalisation
} from '../../selectors';
import {routeUrl} from '../../util/routeUrl';

@customElement('download-sidebar')
export class DownloadSidebar extends connect(store)(navigator(LitElement)) {

	static styles = css`
		:host {
			padding-top: 40px;
			display: flex;
			flex-direction: column;
			gap: var(--large-space);
			width: 400px;
		}
		@media (max-width: 768px) {
			:host {
				width: 100%;
			}
		}

		.title {
			font: var(--font-downloads-title);
			color: var(--color-white);
		}
		.description {
			font: var(--font-downloads-description);
			color: var(--color-white);
		}

		button {
			text-align: left;
			font: var(--font-widget-label);
			color: var(--color-black);
			display: block;
			flex-direction: column;
			justify-content: space-between;
			gap: var(--padding);
			background-color: transparent;
			border: none;
			cursor: pointer;
		}
		.closeButton {
			cursor: pointer;
			background: transparent;
			border: none;
			width: 30px;
			color: #000;
		}
		.closeButton svg {
			width: 100%;
			height: auto;
		}
		.downloadButtons {
			display: flex;
			flex-direction: column;
			padding-bottom: var(--padding);
			gap: var(--very-small-padding);
		}

		.downloadButton {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-small-title);
			padding: var(--very-small-padding) var(--padding);
			color:  var(--color-black);
			background-color: var(--color-white);
		}

		.personaliseButton {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-small-title);
			padding: var(--very-small-padding) var(--padding);
			color: var(--color-black);
			background-color: var(--color-white);
		}

		.downloadItems {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			margin-bottom: auto;
			padding-bottom: var(--padding);
		}


		.downloadItem {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			text-align: left;
			font: var(--font-widget-label);
			color: var(--color-white);
			padding: var(--very-small-padding) 0;
			margin-bottom: 0;
			width: 100%;
			background-color: transparent;
			border: none;
			cursor: pointer;
			border-bottom: 1px solid var(--color-grey3);
		}
		.downloadItem:first-child {
			border-top: 1px solid var(--color-grey3);
		}


		.downloadItem:disabled .label,
		.downloadItem.disabled .label {
			color: var(--color-grey5);
			border-color: var(--color-grey5);
		}

		.icon {
			display: inline-block;
			height: 16px;
			width: 16px;
			margin-right: 10px;
			color: var(--color-black);
		}
		.downloadButton .icon {
			color: var(--color-black);
		}
		.icon.state {
			color: var(--color-warn);
		}
		.icon.state.satisfied {
			color: var(--color-ok);
		}

		.icon svg {
			width: 100%;
			height: auto;
		}

	`;


	@property({type: Boolean})
	tenderTextCopied = false;

	constructor() {
		super();
		this.closeTimout = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = state.status.lang;
		this.downloadStatus = state.download.status;
		this.downloadPngStatus = state.download.statusPng;
		this.specsheetType = state.status.specsheetType;

		this.relux = selectRelux(state);
		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		this.session = selectSpcSession(state);
		this.spcConfiguration = selectSpcConfiguration(state);
		this.basicSpcAttributes = selectBasicSpcAttributes(state);
		this.isBasicSatisfied = selectBasicSpcAttributesSatisfied(state);
		this.detailSpcAttributes = selectDetailSpcAttributes(state);
		this.showPersonalisation = selectShowPersonalisation(state);
	}

	connectedCallback() {
		super.connectedCallback();
	}

	async downloadPDF(e) {
		// capture images
		if (selectFamily(this.state) === 'Olivio') {
			const event = new CustomEvent('captureImages', {bubbles: true, composed: true});
			this.dispatchEvent(event);

			await store.dispatch(storeConfiguration());

			// wait for images to be saved
			// TODO: sync process
			setTimeout(() => store.dispatch(downloadPDF({type: this.specsheetType})), 1000);
		} else {
			store.dispatch(downloadPDF({type: this.specsheetType}));
		}
	}

	downloadPNG(e) {
		if (selectFamily(this.state) === 'Olivio') {
			const event = new CustomEvent('captureImages', {bubbles: true, composed: true});
			this.dispatchEvent(event);
			setTimeout(() => store.dispatch(downloadPNG()), 500);
		} else {
			store.dispatch(downloadPNG({}));
		}

	}

	editConfiguration(e) {
		this.closeSpecsheet();
	}

	startNewConfiguration(e) {
		//this.closeSpecsheet();
		if (!this.status.embed) {
			this.navigate(routeUrl({media: 'sections', key: 'new'}));
		}
		window.location.reload();
	}

	copyTendertext(e) {
		const event = new CustomEvent('copyToClipboard', {
			bubbles: true,
			composed: true
		});
		this.dispatchEvent(event);
		this.tenderTextCopied = true;
	}

	showSpecsheet(type) {
		if (!this.spcIsSatisfied && type === 'detail') {
			//	this.explainNotSatisfied();
		} else {
			clearTimeout(this.closeTimout);
			this.specsheetType = type;
			this.specsheet = true;
			this.active = false;
		}
	}

	download(url) {
		window.open(url);
	}
	reluxUrl(type) {
		return this.relux?.find(r => r.type === type)?.url;
	}
	hideSpecsheet(type) {
		store.dispatch(setDownloadPanelSpecsheetActive({downloadPanelSpecsheetActive: false, type: null}));
	}

	togglePersonalise() {
		store.dispatch(updatePersonalisation({name: 'active', value: !this.showPersonalisation}));
	}

	render() {
		const familyString = selectFamily(this.state);
		return html`
			${when(this.state.status.embed, () => html`
				<button class="closeButton" @click="${() => this.hideSpecsheet()}">${arrowAltLeft}</button>`)}
			<div class="title">
				${msg('The first step is done.')}
			</div>
			<div class="description">
				${msg('Your lighting configuration is ready for download.')}
			</div>
			<language-switch></language-switch>
			<div class="downloadButtons">
				<button class="personaliseButton" @click="${() => this.togglePersonalise()}">
					<span>${this.showPersonalisation? msg('Hide Personalisation') : msg('Personalise Specsheet')}</span>
					<span class="icon">${personalisation}</span>
				</button>
				<button class="downloadButton ${classMap({loading: this.downloadStatus === 'loading'})}"
						@click="${() => this.downloadPDF()}">
					<span>${msg('Download PDF')}</span>
					<span class="icon">${this.downloadStatus === 'loading' ? loading : download}</span>
				</button>
				<button class="downloadButton" @click="${() => this.copyTendertext()}">
					<span>${msg('Copy Tendertext to Clipboard')}</span>
					<span class="icon">${this.tenderTextCopied ? checkmark : download}</span>
				</button>
				<button class="downloadButton" @click="${() => this.startNewConfiguration()}">
					<span>${msg('Start new Configuration')}</span>
					<span class="icon">${reset}</span>
				</button>
			</div>
			<div class="downloadItems">
				${when(selectProductImagesUrl(this.state), () => html`
					<button class="downloadItem"
							@click=${() => this.download(selectProductImagesUrl(this.state) + '/product/' + familyString.toLowerCase())}>
						<span class="label">${msg('Product Images')}</span>
						<span class="icon">${download}</span>
					</button>
					<button class="downloadItem"
							@click=${() => this.download(selectProductImagesUrl(this.state) + '/project/' + familyString.toLowerCase())}>
						<span class="label">${msg('Project Images')}</span>
						<span class="icon">${download}</span>
					</button>
				`)}
				${when(selectMountingInstruction(this.state) !== null, () => html`
					<button class="downloadItem"
							?disabled=${selectMountingInstruction(this.state) !== null && selectMountingInstruction(this.state) === ''}
							@click=${() => this.download(selectMountingInstruction(this.state))}>
						<span class="label">${msg('Mounting instructions')}</span>
						<span class="icon">${download}</span>
					</button>
				`)}
				${when(this.specsheetType === 'family' && selectFamilyFile(this.state) !== null, () => html`
					<button class="downloadItem" ?disabled=${selectFamilyFile(this.state) === null}
							@click=${() => this.download(selectFamilyFile(this.state))}>
						<span class="label">${msg('LDT Files')}</span>
						<span class="icon">${download}</span>
					</button>
				`)}

				${when(this.specsheetType !== 'family', () => html`

					${when(selectFamily(this.state) !== 'Olivio',
			() => html`
							${when(selectLdt1(this.state) !== null, () => html`
								<button class="downloadItem" ?disabled=${selectLdt1(this.state) === null}
										@click=${() => this.download(selectLdt1(this.state))}>
									<span class="label">LDT</span>
									<span class="icon">${download}</span>
								</button>
							`)}
							${when(selectLdt2(this.state) !== null, () => html`
								<button class="downloadItem" ?disabled=${selectLdt2(this.state) === null}
										@click=${() => this.download(selectLdt2(this.state))}>
									<span class="label">LDT 2</span>
									<span class="icon">${download}</span>
								</button>
							`)}
						`)}

					${when(this.reluxUrl('dwg') !== undefined, () => html`
						<button class="downloadItem" ?disabled=${this.reluxUrl('dwg') === undefined}
								@click=${() => this.download(this.reluxUrl('dwg'))}>
							<span class="label">DWG</span>
							<span class="icon">${download}</span>
						</button>
					`)}
					${when(this.reluxUrl('ies') !== undefined, () => html`
						<button class="downloadItem" ?disabled=${this.reluxUrl('ies') === undefined}
								@click=${() => this.download(this.reluxUrl('ies'))}>
							<span class="label">IES</span>
							<span class="icon">${download}</span>
						</button>
					`)}
					${when(this.reluxUrl('rfa') !== undefined, () => html`
						<button class="downloadItem" ?disabled=${this.reluxUrl('rfa') === undefined}
								@click=${() => this.download(this.reluxUrl('rfa'))}>
							<span class="label">RFA</span>
							<span class="icon">${download}</span>
						</button>`)}
					${when(this.reluxUrl('rfa') !== undefined, () => html`
						<button class="downloadItem" ?disabled=${this.reluxUrl('rolfz') === undefined}
								@click=${() => this.download(this.reluxUrl('rolfz'))}>
							<span class="label">ROLFZ</span>
							<span class="icon">${download}</span>
						</button>
					`)}
				`)}

			</div>

			${when(selectFamily(this.state) === 'Olivio',
			() => html`
					<olivio-downloads-for-sidebar></olivio-downloads-for-sidebar>
				`)}
		`;
	}
}

